import { FULL_DECK_CORE } from '../derived/full-deck';
import {
  CardPlaceholderEntrySchema,
  type CardPlaceholderEntry,
} from '../internal/types';

const gradientFor = (card: (typeof FULL_DECK_CORE)[number]): string => {
  if (card.arcana === 'major') {
    return 'major-obsidian-gold';
  }

  switch (card.suit) {
    case 'Bastoni':
      return 'embers-gold';
    case 'Coppe':
      return 'tide-rose';
    case 'Spade':
      return 'mist-steel';
    case 'Denari':
    default:
      return 'moss-coin';
  }
};

export const CARD_PLACEHOLDERS: CardPlaceholderEntry[] = FULL_DECK_CORE.map((card) =>
  CardPlaceholderEntrySchema.parse({
    card_id: card.id,
    gradient_preset: gradientFor(card),
    symbol_emoji: card.symbol_emoji,
    label: card.name,
    badge: card.arcana === 'major' ? 'Maggiore' : card.suit ?? 'Minore',
  }),
);
